module.exports = __webpack_public_path__ + "img/logo-destino-tolima-w.7b12de54.png";